<template>
  <v-container dark class="cmpbk black--text" id="home-container">
    <v-dialog
      dark
      v-model="internalDialog"
      max-width="800"
      persistent
      scrollable
    >
      <v-card dark outlined>
        <v-toolbar flat color="accent" class="black--text" dark>
          <v-toolbar-title class="black--text">Select Images</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-container fluid>
            <v-row dense>
              <v-col
                v-for="img in images"
                :key="img.badge_imageId"
                cols="6"
                sm="4"
                md="3"
              >
                <v-hover v-slot="{ hover }">
                  <v-card
                    :elevation="hover || isSelected(img) ? 8 : 2"
                    :class="{ 'border-primary': isSelected(img) }"
                    class="d-flex align-center justify-center"
                    @click.stop.prevent="toggleSelection(img)"
                  >
                    <v-img :src="img.url" aspect-ratio="1" contain></v-img>
                    <v-overlay absolute opacity="0.5" :value="isSelected(img)">
                      <v-icon large>$checkedcircle</v-icon>
                    </v-overlay>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>

          <v-divider class="my-2"></v-divider>

          <div>
            <v-chip
              v-for="(sel, i) in selected"
              :key="i"
              class="ma-1"
              color="primary"
              dark
              small
            >
              {{ sel.filename }}
            </v-chip>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="close">Cancel</v-btn>
          <v-btn color="primary" dark @click="confirmSelection">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

.border-primary {
  border: 2px solid #1976d2;
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "ImagePickerDialog",
  mixins: [bus_common],
  props: {
    images: {
      type: Array,
      required: true,
    },
    show_dialog: {
      type: Boolean,
      required: true,
    },
    clearimages: {
      type: Date,
      default: null,
    },
    selectedIds: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    selected: [],
  }),
  computed: {
    internalDialog: {
      get() {
        return this.show_dialog;
      },
      set(val) {
        this.$emit("update:show_dialog", val);
      },
    },
  },
  watch: {
    show_dialog() {
      console.log("Dialog changed");
      this.populateSelectedFromIds();
    },
  },
  methods: {
    populateSelectedFromIds() {
      console.log("populateSelectedFromIds() running");
      console.log("selectedIds =", this.selectedIds);
      console.log("images =", this.images);

      this.selected = [];

      if (!this.selectedIds || this.selectedIds === "") {
        if (this.images[2]) {
          console.log("Using default image at index 2:", this.images[2]);
          this.selected.push({ ...this.images[2] });
        }
        console.log("selected after default =", this.selected);
        return;
      }

      const arr = this.selectedIds.split("|").map(Number);
      console.log("parsed array:", arr);

      arr.forEach((id) => {
        const img = this.images.find((x) => x.badge_imageId == id);
        console.log("id:", id, "match:", img);
        if (img) {
          this.selected.push({ ...img });
        }
      });

      console.log("final selected =", this.selected);
    },
    close() {
      this.internalDialog = false;
    },
    isSelected(img) {
      const hit = this.selected.some(
        (s) => s.badge_imageId === img.badge_imageId
      );
      console.log(
        "isSelected?",
        img.badge_imageId,
        "=>",
        hit,
        "selected=",
        this.selected.map((s) => s.badge_imageId)
      );
      return hit;
    },
    toggleSelection(img) {
      const idx = this.selected.findIndex(
        (s) => s.badge_imageId === img.badge_imageId
      );
      if (idx >= 0) {
        this.selected.splice(idx, 1);
      } else {
        this.selected.push({ ...img });
      }
    },
    confirmSelection() {
      this.$emit(
        "save",
        this.selected.map((img) => img.badge_imageId)
      );
      this.close();
    },
  },
};
</script>
